import { render } from "./AvatarRatio.vue?vue&type=template&id=26bcd52e"
import script from "./AvatarRatio.vue?vue&type=script&lang=ts"
export * from "./AvatarRatio.vue?vue&type=script&lang=ts"
script.render = render

export default script